const generalConstants = {
  MOBILE_SCREEN_WIDTH: 768
};

export default generalConstants;